import { useMutation } from '@tanstack/react-query'
import { postJobApplication } from "./api"

export const useMutationJobApplication = (options = {}) => {
  return useMutation({
    mutationFn: (params) => postJobApplication(params),
    ...options
  })
}
